import { getRoleFromToken } from 'core/apis/common';
import dashboard from './dashboard';
import { role } from 'core/constant/constants';
import adminDashboard from './adminDashboard';

const checkRole = getRoleFromToken()

const menuItems = {
  items: [checkRole == role?.superAdmin ? adminDashboard : dashboard]
};

export default menuItems;
